import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const modrinth = defineConnector({
  identifier: "modrinth",
  name: "Modrinth",
  tagLine: "Open-source mod hosting platform",
  logo,
  protocol: "http",
  tags: ["engineering"],
  defaultUrlPattern: () => "https://api\\.modrinth\\.com/.*",
  auth: (app) =>
    headerAuth([{ name: "Authorization", value: app.secret.apiToken }]),
  steps: [
    {
      title: "Get your Modrinth token",
      items: [
        {
          kind: "markdown",
          content:
            "Go to [Modrinth Settings](https://modrinth.com/settings/pats) and create a **personal access token**.",
        },
        {
          kind: "input",
          label: "Personal access token",
          required: true,
          target: { kind: "secrets", field: "apiToken" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => "https://api.modrinth.com/v2/user",
  },
});
